import { money } from 'services/graphql/fragments/Fragments';
import { AnalyticsFragment } from 'services/graphql/fragments/VxlFragments';
import { gql } from 'urql';

const getMyCashbackComponent = gql`
  query GetMyCashbackComponent {
    myPartnerOffers {
      myCashbackComponent {
        __typename
        ... on MyCashbackComponentError {
          code
          message
          title
        }
        ... on MyCashbackComponentSuccess {
          id
          myCashbackComponent {
            id
            title
            subtitle
            yearToDateEarnings {
              ...money
            }
            onClick {
              route
              analyticsEvent {
                ...analytics
              }
            }
            displayAnalytics {
              ...analytics
            }
          }
          displayAnalytics {
            ...analytics
          }
        }
      }
    }
  }
  ${money}
  ${AnalyticsFragment}
`;

export default getMyCashbackComponent;
